import React, { useState, useEffect, useContext } from "react";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Pagination from "@material-ui/lab/Pagination";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { UsersFilter } from "../../components/UsersFilter";
import { TagsFilter } from "../../components/TagsFilter";
import { WhatsappsFilter } from "../../components/WhatsappsFilter";
import { StatusFilter } from "../../components/StatusFilter";
import { ChannelFilter } from "../../components/ChannelFilter";
import { SupportTimeFilter } from "../../components/SupportTimeFilter";
import useDashboard from "../../hooks/useDashboard";

import QueueSelectCustom from "../../components/QueueSelectCustom";
import moment from "moment";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";
import IconChannel from "../../components/IconChannel";

import { blue, green } from "@material-ui/core/colors";
import {
  Forward,
  History,
  SaveAlt,
  PictureAsPdf,
  WhatsApp,
  AttachMoney,
  MoneyOff,
  Chat,
} from "@material-ui/icons";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: theme.palette.fancyBackground,
  },
  formControl: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  mainPaper: {
    flex: 1,
    marginTop: 40,
    borderRadius: 20,
    border: "0px !important",
    marginBottom: 40,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  mainPaperTable: {
    flex: 1,
    overflow: "auto",
    height: "68vh",
    ...theme.scrollbarStylesSoftBig,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      maxHeight: "50vh",
      marginTop: theme.spacing(2),
    },
  },
  mainPaperFilter: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
    ...theme.scrollbarStylesSoftBig,
    [theme.breakpoints.down("sm")]: {
      maxHeight: "20vh",
      overflowY: "auto",
      marginBottom: theme.spacing(2),
    },
  },
  mainHeaderBlock: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexWrap: "wrap",
    },
  },
  mainHeaderFilter: {
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      zIndex: 1,
    },
  },
  filterItem: {
    width: 200,
    [theme.breakpoints.down("md")]: {
      width: "45%",
    },
  },
  // Estilos melhorados para a tabela
  tableHead: {
    "& th": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff !important",
      fontWeight: 600,
      fontSize: "0.8rem",
      padding: "12px 8px",
      whiteSpace: "nowrap",
      borderBottom: "none",
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
      backgroundColor: theme.palette.action.selected,
    },
    "& td": {
      padding: "10px 8px",
      fontSize: "0.85rem",
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusChip: {
    fontSize: "0.7rem",
    height: 24,
    fontWeight: 500,
  },
  statusOpen: {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  statusClosed: {
    backgroundColor: "#e8f5e9",
    color: "#388e3c",
  },
  statusPending: {
    backgroundColor: "#fff3e0",
    color: "#f57c00",
  },
  channelIcon: {
    verticalAlign: "middle",
    marginRight: 4,
  },
  saleYes: {
    color: "#388e3c",
    fontWeight: 600,
  },
  saleNo: {
    color: "#d32f2f",
  },
  supportTimeCell: {
    fontFamily: "monospace",
    fontSize: "0.8rem",
  },
  lastMessageCell: {
    maxWidth: 200,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  actionButton: {
    padding: 4,
  },
}));

const Reports = () => {
  const classes = useStyles();
  const history = useHistory();
  const { getReport } = useDashboard();

  useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Defina o tamanho da página

  const [searchParam, setSearchParam] = useState("");
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [tagIds, setTagIds] = useState([]);
  const [queueIds, setQueueIds] = useState([]);
  const [userIds, setUserIds] = useState([]);
  const [options, setOptions] = useState([]);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [onlyRated, setOnlyRated] = useState(false);
  const [totalTickets, setTotalTickets] = useState(0);
  const [tickets, setTickets] = useState([]);

  // Novos filtros
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [supportTimeFilter, setSupportTimeFilter] = useState(null);
  const [saleFilter, setSaleFilter] = useState(""); // "", "yes", "no"
  const [ticketIdFilter, setTicketIdFilter] = useState(""); // Filtro por ID do ticket
  const [selectedKanbanLane, setSelectedKanbanLane] = useState("");
  const [kanbanLanes, setKanbanLanes] = useState([]);

  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(null);

  useEffect(() => {
    const fetchKanbanLanes = async () => {
      try {
        const { data } = await api.get("/tag/kanban");
        setKanbanLanes(
          Array.isArray(data) ? data : data?.lista || data?.tags || []
        );
      } catch (err) {
        console.error("Erro ao buscar lanes kanban:", err);
      }
    };
    fetchKanbanLanes();
  }, []);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts", {
            params: { searchParam },
          });
          setOptions(data.contacts);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setTagIds(tags);
  };

  const exportarGridParaExcel = async () => {
    setLoading(true); // Define o estado de loading como true durante o carregamento

    try {
      const data = await getReport({
        searchParam,
        contactId: selectedContactId,
        whatsappId: JSON.stringify(selectedWhatsapp),
        tags: JSON.stringify(tagIds),
        users: JSON.stringify(userIds),
        queueIds: JSON.stringify(queueIds),
        status: JSON.stringify(selectedStatus),
        dateFrom,
        dateTo,
        page: 1, // Passa o número da página para a API
        pageSize: 9999999, // Passa o tamanho da página para a API
        onlyRated: onlyRated ? "true" : "false",
        channels: JSON.stringify(selectedChannels),
        supportTimeMin: supportTimeFilter?.minMinutes || null,
        supportTimeMax: supportTimeFilter?.maxMinutes || null,
        finalizadoComVenda: saleFilter || null,
        ticketId: ticketIdFilter || null,
        kanbanLane: selectedKanbanLane || null,
      });

      const ticketsData = data.tickets.map((ticket) => {
        const formatDate = (dateString) => {
          if (!dateString || dateString === null) {
            return { date: "", time: "" };
          }

          if (dateString.includes("/") && dateString.includes(" ")) {
            const [datePart, timePart] = dateString.split(" ");
            return {
              date: datePart,
              time: timePart,
            };
          }

          const date = new Date(dateString);
          if (isNaN(date.getTime())) {
            return { date: "", time: "" };
          }

          return {
            date: date.toLocaleDateString("pt-BR"),
            time: date.toLocaleTimeString("pt-BR"),
          };
        };

        const formatSupportTime = (timeString) => {
          if (!timeString) return "";

          if (timeString === "0") return "0min";

          const match = timeString.match(
            /(\d+)\s*d,?\s*(\d+)\s*hr?s?\s*e?\s*(\d+)\s*m/
          );
          if (!match) return timeString;

          const days = parseInt(match[1]);
          const hours = parseInt(match[2]);
          const minutes = parseInt(match[3]);

          let result = "";
          if (days > 0) result += `${days}d`;
          if (hours > 0) result += `${hours}h`;
          if (minutes > 0) result += `${minutes}min`;

          return result || "0min";
        };

        const createdAtFormatted = formatDate(ticket.createdAt);
        const closedAtFormatted = formatDate(ticket.closedAt);

        return {
          id: ticket.id,
          Conexão: ticket.whatsappName,
          Contato: ticket.contactName,
          WhatsApp: ticket.contactNumber || "-",
          Usuário: ticket.userName,
          Fila: ticket.queueName,
          Status: ticket.status,
          ÚltimaMensagem: ticket.lastMessage,
          DataAbertura: createdAtFormatted.date,
          HoraAbertura: createdAtFormatted.time,
          DataFechamento: closedAtFormatted.date,
          HoraFechamento: closedAtFormatted.time,
          TempoDeAtendimento: formatSupportTime(ticket.supportTime),
          nps: ticket.NPS || "",
          ValorDaVenda:
            ticket.valorVenda !== undefined && ticket.valorVenda !== null
              ? ticket.valorVenda
              : "-",
          MotivoDaNaoVenda: ticket.motivoNaoVenda || "-",
          FinalizadoComVenda:
            ticket.finalizadoComVenda === true
              ? "Sim"
              : ticket.finalizadoComVenda === false
              ? "Não"
              : "-",
        };
      });

      console.log(ticketsData);

      // RDS.CHAT - preparando os dados aqui...
      const getTranslation = (key, fallback) => {
        const translation = i18n.t(key);
        return translation !== key ? translation : fallback;
      };

      const formatDateBR = (dateStr) => {
        if (!dateStr)
          return getTranslation(
            "reports.exportExcel.notInformed",
            "Não informado"
          );
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
      };

      const translations = {
        title: getTranslation(
          "reports.exportExcel.title",
          "Relatórios de Atendimentos"
        ),
        startDate: getTranslation(
          "reports.exportExcel.startDate",
          "Data inicial"
        ),
        endDate: getTranslation("reports.exportExcel.endDate", "Data final"),
        columns: {
          id: getTranslation("reports.exportExcel.columns.id", "ID"),
          connection: getTranslation(
            "reports.exportExcel.columns.connection",
            "Conexão"
          ),
          contact: getTranslation(
            "reports.exportExcel.columns.contact",
            "Contato"
          ),
          user: getTranslation("reports.exportExcel.columns.user", "Usuário"),
          queue: getTranslation("reports.exportExcel.columns.queue", "Fila"),
          status: getTranslation(
            "reports.exportExcel.columns.status",
            "Status"
          ),
          lastMessage: getTranslation(
            "reports.exportExcel.columns.lastMessage",
            "Última Mensagem"
          ),
          openDate: getTranslation(
            "reports.exportExcel.columns.openDate",
            "Data Abertura"
          ),
          openTime: getTranslation(
            "reports.exportExcel.columns.openTime",
            "Hora Abertura"
          ),
          closeDate: getTranslation(
            "reports.exportExcel.columns.closeDate",
            "Data Fechamento"
          ),
          closeTime: getTranslation(
            "reports.exportExcel.columns.closeTime",
            "Hora Fechamento"
          ),
          supportTime: getTranslation(
            "reports.exportExcel.columns.supportTime",
            "Tempo de Atendimento"
          ),
          nps: getTranslation("reports.exportExcel.columns.nps", "NPS"),
          valorVenda: getTranslation(
            "reports.exportExcel.columns.valorVenda",
            "Valor da Venda"
          ),
          motivoNaoVenda: getTranslation(
            "reports.exportExcel.columns.motivoNaoVenda",
            "Motivo da Não Venda"
          ),
          finalizadoComVenda: getTranslation(
            "reports.exportExcel.columns.finalizadoComVenda",
            "Finalizado com Venda"
          ),
        },
      };

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet([
        [translations.title],
        [`${translations.startDate}: ${formatDateBR(dateFrom)}`],
        [`${translations.endDate}: ${formatDateBR(dateTo)}`],
        [],
        [
          translations.columns.id,
          translations.columns.connection,
          translations.columns.contact,
          "WhatsApp",
          translations.columns.user,
          translations.columns.queue,
          translations.columns.status,
          translations.columns.lastMessage,
          translations.columns.openDate,
          translations.columns.openTime,
          translations.columns.closeDate,
          translations.columns.closeTime,
          translations.columns.supportTime,
          translations.columns.nps,
          translations.columns.valorVenda,
          translations.columns.motivoNaoVenda,
          translations.columns.finalizadoComVenda,
        ],
      ]);

      XLSX.utils.sheet_add_json(ws, ticketsData, {
        origin: "A6",
        skipHeader: true,
      });

      if (!ws["!merges"]) ws["!merges"] = [];
      ws["!merges"].push({ s: { c: 0, r: 0 }, e: { c: 16, r: 0 } });

      if (!ws["!cols"]) ws["!cols"] = [];
      ws["!cols"] = [
        { wch: 8 },
        { wch: 15 },
        { wch: 25 },
        { wch: 15 },
        { wch: 20 },
        { wch: 15 },
        { wch: 12 },
        { wch: 30 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 18 },
        { wch: 8 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];

      if (!ws["!rows"]) ws["!rows"] = [];
      ws["!rows"] = [
        { hpt: 25 },
        { hpt: 20 },
        { hpt: 20 },
        { hpt: 10 },
        { hpt: 25 },
      ];

      const range = XLSX.utils.decode_range(ws["!ref"]);

      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          if (!ws[cellAddress]) continue;

          if (!ws[cellAddress].s) ws[cellAddress].s = {};

          if (rowNum === 0) {
            ws[cellAddress].s = {
              font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
              fill: { fgColor: { rgb: "4472C4" } },
              alignment: { horizontal: "center", vertical: "center" },
            };
          } else if (rowNum === 1 || rowNum === 2) {
            ws[cellAddress].s = {
              font: { bold: true, sz: 12 },
              fill: { fgColor: { rgb: "E7E6E6" } },
            };
          } else if (rowNum === 4) {
            ws[cellAddress].s = {
              font: { bold: true, color: { rgb: "FFFFFF" } },
              fill: { fgColor: { rgb: "70AD47" } },
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendimentos");
      XLSX.writeFile(wb, "relatorio-de-atendimentos.xlsx", {
        cellStyles: true,
        bookType: "xlsx",
      });

      setPageNumber(pageNumber);
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  const exportarGridParaPDF = async () => {
    setLoading(true);

    try {
      const data = await getReport({
        searchParam,
        contactId: selectedContactId,
        whatsappId: JSON.stringify(selectedWhatsapp),
        tags: JSON.stringify(tagIds),
        users: JSON.stringify(userIds),
        queueIds: JSON.stringify(queueIds),
        status: JSON.stringify(selectedStatus),
        dateFrom,
        dateTo,
        page: 1,
        pageSize: 9999999,
        onlyRated: onlyRated ? "true" : "false",
        channels: JSON.stringify(selectedChannels),
        supportTimeMin: supportTimeFilter?.minMinutes || null,
        supportTimeMax: supportTimeFilter?.maxMinutes || null,
        finalizadoComVenda: saleFilter || null,
        ticketId: ticketIdFilter || null,
      });

      const ticketsData = data.tickets;

      if (!ticketsData || ticketsData.length === 0) {
        toastError("Nenhum dado para exportar");
        setLoading(false);
        return;
      }

      // Criar PDF
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      let yPos = margin;

      // Cores
      const primaryColor = [25, 118, 210]; // Azul
      const headerBg = [66, 66, 66]; // Cinza escuro
      const altRowBg = [245, 245, 245]; // Cinza claro

      // Titulo
      doc.setFillColor(...primaryColor);
      doc.rect(0, 0, pageWidth, 20, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Relatorio de Atendimentos", pageWidth / 2, 13, { align: "center" });

      // Subtitulo com periodo
      yPos = 28;
      doc.setTextColor(100, 100, 100);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      const formatDateBR = (dateStr) => {
        if (!dateStr) return "-";
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
      };
      doc.text(`Periodo: ${formatDateBR(dateFrom)} a ${formatDateBR(dateTo)} | Total: ${ticketsData.length} registros`, pageWidth / 2, yPos, { align: "center" });

      yPos = 38;

      // Configuracao das colunas
      const columns = [
        { header: "ID", width: 12, align: "center" },
        { header: "Conexao", width: 28, align: "left" },
        { header: "Contato", width: 35, align: "left" },
        { header: "Telefone", width: 28, align: "left" },
        { header: "Atendente", width: 28, align: "left" },
        { header: "Fila", width: 22, align: "left" },
        { header: "Status", width: 18, align: "center" },
        { header: "Abertura", width: 28, align: "center" },
        { header: "Fechamento", width: 28, align: "center" },
        { header: "Tempo", width: 22, align: "center" },
        { header: "NPS", width: 12, align: "center" },
        { header: "Venda", width: 14, align: "center" },
      ];

      const totalWidth = columns.reduce((sum, col) => sum + col.width, 0);
      const startX = (pageWidth - totalWidth) / 2;

      // Funcao para desenhar cabecalho
      const drawHeader = () => {
        doc.setFillColor(...headerBg);
        doc.rect(startX, yPos, totalWidth, 8, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");

        let xPos = startX;
        columns.forEach((col) => {
          const textX = col.align === "center" ? xPos + col.width / 2 : xPos + 2;
          doc.text(col.header, textX, yPos + 5.5, { align: col.align === "center" ? "center" : "left" });
          xPos += col.width;
        });

        yPos += 8;
      };

      // Funcao para desenhar linha de dados
      const drawRow = (ticket, isAlt) => {
        const rowHeight = 7;

        // Background alternado
        if (isAlt) {
          doc.setFillColor(...altRowBg);
          doc.rect(startX, yPos, totalWidth, rowHeight, "F");
        }

        // Borda inferior
        doc.setDrawColor(220, 220, 220);
        doc.line(startX, yPos + rowHeight, startX + totalWidth, yPos + rowHeight);

        doc.setTextColor(60, 60, 60);
        doc.setFontSize(7);
        doc.setFont("helvetica", "normal");

        const truncate = (str, maxLen) => {
          if (!str) return "-";
          str = String(str);
          return str.length > maxLen ? str.substring(0, maxLen - 2) + ".." : str;
        };

        const values = [
          `#${ticket.id}`,
          truncate(ticket.whatsappName, 18),
          truncate(ticket.contactName, 22),
          truncate(ticket.contactNumber, 16),
          truncate(ticket.userName, 18),
          truncate(ticket.queueName, 14),
          ticket.status || "-",
          ticket.createdAt || "-",
          ticket.closedAt || "-",
          ticket.supportTime || "-",
          ticket.NPS || "-",
          ticket.finalizadoComVenda === true ? "Sim" : ticket.finalizadoComVenda === false ? "Nao" : "-",
        ];

        let xPos = startX;
        columns.forEach((col, idx) => {
          const textX = col.align === "center" ? xPos + col.width / 2 : xPos + 2;
          doc.text(String(values[idx]), textX, yPos + 4.5, { align: col.align === "center" ? "center" : "left" });
          xPos += col.width;
        });

        yPos += rowHeight;
      };

      // Desenhar cabecalho inicial
      drawHeader();

      // Desenhar linhas de dados
      ticketsData.forEach((ticket, index) => {
        // Verificar se precisa de nova pagina
        if (yPos > pageHeight - 15) {
          doc.addPage();
          yPos = margin;
          drawHeader();
        }

        drawRow(ticket, index % 2 === 1);
      });

      // Rodape
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(`Pagina ${i} de ${totalPages}`, pageWidth - margin, pageHeight - 5, { align: "right" });
        doc.text(`Gerado em ${new Date().toLocaleString("pt-BR")}`, margin, pageHeight - 5);
      }

      // Salvar PDF
      doc.save("relatorio-de-atendimentos.pdf");

    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = async (pageNumber) => {
    setLoading(true); // Define o estado de loading como true durante o carregamento
    console.log(onlyRated);
    try {
      const data = await getReport({
        searchParam,
        contactId: selectedContactId,
        whatsappId: JSON.stringify(selectedWhatsapp),
        tags: JSON.stringify(tagIds),
        users: JSON.stringify(userIds),
        queueIds: JSON.stringify(queueIds),
        status: JSON.stringify(selectedStatus),
        dateFrom,
        dateTo,
        page: pageNumber, // Passa o número da página para a API
        pageSize: pageSize, // Passa o tamanho da página para a API
        onlyRated: onlyRated ? "true" : "false",
        channels: JSON.stringify(selectedChannels),
        supportTimeMin: supportTimeFilter?.minMinutes || null,
        supportTimeMax: supportTimeFilter?.maxMinutes || null,
        finalizadoComVenda: saleFilter || null,
        ticketId: ticketIdFilter || null,
        kanbanLane: selectedKanbanLane || null,
      });

      setTotalTickets(data.totalTickets.total);

      setTickets(data.tickets); // Se for a primeira página, substitua os tickets

      setPageNumber(pageNumber); // Atualiza o estado da página atual
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false); // Define o estado de loading como false após o carregamento
    }
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setUserIds(users);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);
    setSelectedWhatsapp(whatsapp);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    setSelectedStatus(statusFilter);
  };

  const handleSelectedChannels = (channels) => {
    setSelectedChannels(channels);
  };

  const handleSupportTimeFilter = (filter) => {
    setSupportTimeFilter(filter);
  };
  const renderOption = (option) => {
    if (option.number) {
      return (
        <>
          {IconChannel(option.channel)}
          <Typography
            component="span"
            style={{
              fontSize: 14,
              marginLeft: "10px",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: "2",
            }}
          >
            {option.name} - {option.number}
          </Typography>
        </>
      );
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const handleSelectOption = (e, newValue) => {
    setSelectedContactId(newValue.id);
    setSearchParam("");
  };

  const renderOptionLabel = (option) => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };
  const filter = createFilterOptions({
    trim: true,
  });

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };
  const renderContactAutocomplete = () => {
    return (
      <Autocomplete
        fullWidth
        options={options}
        loading={loading}
        clearOnBlur
        autoHighlight
        freeSolo
        size="small"
        clearOnEscape
        getOptionLabel={renderOptionLabel}
        renderOption={renderOption}
        filterOptions={createAddContactOption}
        onChange={(e, newValue) => handleSelectOption(e, newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={i18n.t("newTicketModal.fieldLabel")}
            variant="outlined"
            autoFocus
            size="small"
            onChange={(e) => setSearchParam(e.target.value)}
            // onKeyPress={(e, newValue) => handleSelectOption(e, newValue)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  return (
    <MainContainer className={classes.mainContainer}>
      {openTicketMessageDialog && (
        <ShowTicketLogModal
          isOpen={openTicketMessageDialog}
          handleClose={() => setOpenTicketMessageDialog(false)}
          ticketId={ticketOpen.id}
        />
      )}
      <Title>{i18n.t("reports.title")}</Title>

      <MainHeader
        className={classes.mainHeaderFilter}
        style={{ display: "flex" }}
      >
        <Paper className={classes.mainPaperFilter}>
          <Grid container spacing={1}>
            {/* Primeira linha de filtros - 6 colunas iguais */}
            <Grid item xs={12} sm={6} md={2}>
              {renderContactAutocomplete()}
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <ChannelFilter onFiltered={handleSelectedChannels} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <StatusFilter onFiltered={handleSelectedStatus} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <div style={{ marginTop: -14 }}>
                <QueueSelectCustom
                  selectedQueueIds={queueIds}
                  onChange={(values) => setQueueIds(values)}
                />
              </div>
            </Grid>

            {/* Segunda linha - 6 colunas iguais */}
            <Grid item xs={12} sm={6} md={2}>
              <TagsFilter onFiltered={handleSelectedTags} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Kanban</InputLabel>
                <Select
                  value={selectedKanbanLane}
                  onChange={(e) => setSelectedKanbanLane(e.target.value)}
                  label="Kanban"
                >
                  <MenuItem value="">Todas as lanes</MenuItem>
                  <MenuItem value="0">Sem lane</MenuItem>
                  {kanbanLanes.map((lane) => (
                    <MenuItem key={lane.id} value={lane.id}>
                      <span
                        style={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: lane.color || "#ccc",
                          display: "inline-block",
                          marginRight: 8,
                        }}
                      />
                      {lane.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="ID Ticket"
                type="text"
                value={ticketIdFilter}
                variant="outlined"
                fullWidth
                size="small"
                placeholder="Ex: 123"
                onChange={(e) => setTicketIdFilter(e.target.value.replace(/\D/g, ""))}
                InputProps={{
                  startAdornment: <span style={{ color: "#999", marginRight: 4 }}>#</span>,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SupportTimeFilter onFiltered={handleSupportTimeFilter} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Venda</InputLabel>
                <Select
                  value={saleFilter}
                  onChange={(e) => setSaleFilter(e.target.value)}
                  label="Venda"
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="yes">
                    <AttachMoney style={{ color: "#388e3c", fontSize: 18, marginRight: 4 }} />
                    Sim
                  </MenuItem>
                  <MenuItem value="no">
                    <MoneyOff style={{ color: "#d32f2f", fontSize: 18, marginRight: 4 }} />
                    Nao
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* Terceira linha - Datas + Acoes */}
            <Grid item xs={12}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", marginTop: 4, flexWrap: "wrap" }}>
                <TextField
                  label="Data Inicio"
                  type="date"
                  value={dateFrom}
                  variant="outlined"
                  size="small"
                  onChange={(e) => setDateFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: 160 }}
                />
                <TextField
                  label="Data Fim"
                  type="date"
                  value={dateTo}
                  variant="outlined"
                  size="small"
                  onChange={(e) => setDateTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: 160 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={onlyRated}
                      onChange={() => setOnlyRated(!onlyRated)}
                      size="small"
                    />
                  }
                  label="Apenas com NPS"
                  style={{ marginLeft: 4 }}
                />
                <div style={{ flex: 1 }} />
                <Tooltip title="Exportar para Excel">
                  <IconButton
                    onClick={exportarGridParaExcel}
                    aria-label="Exportar para Excel"
                    size="small"
                    color="primary"
                  >
                    <SaveAlt />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Exportar para PDF">
                  <IconButton
                    onClick={exportarGridParaPDF}
                    aria-label="Exportar para PDF"
                    size="small"
                    style={{ color: "#d32f2f" }}
                  >
                    <PictureAsPdf />
                  </IconButton>
                </Tooltip>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter(pageNumber)}
                  size="small"
                >
                  Filtrar
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </MainHeader>
      <Paper className={classes.mainPaperTable} variant="outlined">
        <Table size="small" id="grid-attendants" stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">Canal</TableCell>
              <TableCell align="left">Conexao</TableCell>
              <TableCell align="left">Contato</TableCell>
              <TableCell align="left">Telefone</TableCell>
              <TableCell align="left">Atendente</TableCell>
              <TableCell align="left">Fila</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="left">Ultima Msg</TableCell>
              <TableCell align="center">Abertura</TableCell>
              <TableCell align="center">Fechamento</TableCell>
              <TableCell align="center">Tempo</TableCell>
              <TableCell align="center">NPS</TableCell>
              <TableCell align="center">Valor</TableCell>
              <TableCell align="center">Venda</TableCell>
              <TableCell align="center">Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {tickets.map((ticket) => (
                <TableRow key={ticket.id} className={classes.tableRow}>
                  <TableCell align="center">
                    <strong>#{ticket.id}</strong>
                  </TableCell>
                  <TableCell align="center">
                    {IconChannel(ticket?.channel || "whatsapp")}
                  </TableCell>
                  <TableCell align="left">{ticket?.whatsappName}</TableCell>
                  <TableCell align="left">
                    <Tooltip title={ticket?.contactName || ""}>
                      <span>{ticket?.contactName?.substring(0, 20)}{ticket?.contactName?.length > 20 ? "..." : ""}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left">{ticket?.contactNumber || "-"}</TableCell>
                  <TableCell align="left">{ticket?.userName || "-"}</TableCell>
                  <TableCell align="left">{ticket?.queueName || "-"}</TableCell>
                  <TableCell align="center">
                    <span className={`${classes.statusChip} ${
                      ticket?.status === "open" ? classes.statusOpen :
                      ticket?.status === "closed" ? classes.statusClosed :
                      classes.statusPending
                    }`} style={{
                      padding: "4px 8px",
                      borderRadius: 12,
                      fontSize: "0.7rem",
                      fontWeight: 500,
                    }}>
                      {ticket?.status}
                    </span>
                  </TableCell>
                  <TableCell align="left" className={classes.lastMessageCell}>
                    <Tooltip title={ticket?.lastMessage || ""}>
                      <span>{ticket?.lastMessage?.substring(0, 30)}{ticket?.lastMessage?.length > 30 ? "..." : ""}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "0.75rem" }}>
                    {ticket?.createdAt}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "0.75rem" }}>
                    {ticket?.closedAt || "-"}
                  </TableCell>
                  <TableCell align="center" className={classes.supportTimeCell}>
                    {ticket?.supportTime || "-"}
                  </TableCell>
                  <TableCell align="center">
                    {ticket?.NPS ? (
                      <span style={{
                        fontWeight: 600,
                        color: ticket.NPS >= 9 ? "#388e3c" : ticket.NPS >= 7 ? "#f57c00" : "#d32f2f"
                      }}>
                        {ticket.NPS}
                      </span>
                    ) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {ticket?.valorVenda !== undefined && ticket?.valorVenda !== null ? (
                      <span style={{ color: "#388e3c", fontWeight: 600 }}>
                        R$ {Number(ticket.valorVenda).toFixed(2)}
                      </span>
                    ) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {ticket?.finalizadoComVenda === true ? (
                      <AttachMoney style={{ color: "#388e3c", fontSize: 20 }} />
                    ) : ticket?.finalizadoComVenda === false ? (
                      <MoneyOff style={{ color: "#d32f2f", fontSize: 20 }} />
                    ) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Logs do Ticket">
                      <IconButton
                        size="small"
                        className={classes.actionButton}
                        onClick={() => {
                          setOpenTicketMessageDialog(true);
                          setTicketOpen(ticket);
                        }}
                      >
                        <History fontSize="small" style={{ color: blue[700] }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Acessar Ticket">
                      <IconButton
                        size="small"
                        className={classes.actionButton}
                        onClick={() => history.push(`/tickets/${ticket.uuid}`)}
                      >
                        <Forward fontSize="small" style={{ color: green[700] }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton avatar columns={3} />}
            </>
          </TableBody>
        </Table>
      </Paper>

      <div>
        <Grid container>
          <Grid item xs={12} sm={10} md={10}>
            <Pagination
              count={Math.ceil(totalTickets / pageSize)} // Calcula o nmero total de páginas com base no nmero total de tickets e no tamanho da página
              page={pageNumber} // Define a página atual
              onChange={(event, value) => handleFilter(value)} // Função de callback para mudanças de página
            />
          </Grid>
          <Grid item xs={12} sm={2} md={2}>
            <FormControl margin="dense" variant="outlined" fullWidth>
              <InputLabel>{i18n.t("tickets.search.ticketsPerPage")}</InputLabel>
              <Select
                labelId="dialog-select-prompt-label"
                id="dialog-select-prompt"
                name="pageSize"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(e.target.value);
                }}
                label={i18n.t("tickets.search.ticketsPerPage")}
                fullWidth
                MenuProps={{
                  anchorOrigin: {
                    vertical: "center",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "center",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={5}>{"5"}</MenuItem>
                <MenuItem value={10}>{"10"}</MenuItem>
                <MenuItem value={20}>{"20"}</MenuItem>
                <MenuItem value={50}>{"50"}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>
    </MainContainer>
  );
};

export default Reports;
